import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5e84fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-panel p-3 lg:p-5 lg:w-[465px] bg-stone-85 border-2 border-solid border-white rounded-xl text-slateGray" }
const _hoisted_2 = { class: "flex items-end gap-4" }
const _hoisted_3 = {
  class: "flex-grow text-xs md:text-base md:mb-5",
  "data-test": "text"
}
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex-grow" }

import useTabIndex from '@/composables/mjp/useTabIndex'
import ArrowButton from './ArrowButton.vue'
import RemedyCategoryBadge from './RemedyCategoryBadge.vue'
import { MJPSection } from '@/components/magicjohnsonpark/types'
import { useEventBus } from '@vueuse/core'
import OverheadMap from '../magicjohnsonpark/OverheadMap.vue'

// displays a panel summarizing a stop
// on the tour map

interface Props {
  title: string
  text: string
  remedyCategories: Array<string>
  section: MJPSection
  currentSection: MJPSection
  index: number
  isActive: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionPanel',
  props: {
    title: null,
    text: null,
    remedyCategories: null,
    section: null,
    currentSection: null,
    index: null,
    isActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  title: string
  text: string
  remedyCategories: Array<string>
  section: MJPSection
  currentSection: MJPSection
  index: number
  isActive: boolean
}


const sectionChangedBus = useEventBus('section-changed')

const handleClickArrowBtn = (evt) => {
  sectionChangedBus.emit({
    section: props.section,
    pageNumber: 0,
    forward: true,
    lastSection: props.currentSection,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", {
      class: "font-serif text-headingSm md:text-headingLg mb-2 md:mb-4 cursor-pointer",
      "data-test": "title",
      onClick: handleClickArrowBtn
    }, _toDisplayString(props.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.text), 1),
      _createVNode(ArrowButton, {
        class: "shrink-0 md:hidden",
        tabindex: 
          props.isActive
            ? _unref(useTabIndex)(
                OverheadMap,
                props.index,
                ArrowButton,
                props.remedyCategories.length
              )
            : -1
        ,
        onClick: handleClickArrowBtn,
        label: props.title
      }, null, 8, ["tabindex", "label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.remedyCategories, (categoryId, index) => {
          return (_openBlock(), _createBlock(RemedyCategoryBadge, {
            key: categoryId,
            class: "hidden md:inline-block",
            tabindex: 
            props.isActive
              ? _unref(useTabIndex)(
                  OverheadMap,
                  props.index,
                  RemedyCategoryBadge,
                  index
                )
              : -1
          ,
            category: categoryId,
            "data-test": categoryId
          }, null, 8, ["tabindex", "category", "data-test"]))
        }), 128))
      ]),
      _createVNode(ArrowButton, {
        class: "shrink-0 hidden md:flex",
        tabindex: 
          props.isActive
            ? _unref(useTabIndex)(
                OverheadMap,
                props.index,
                ArrowButton,
                props.remedyCategories.length
              )
            : -1
        ,
        onClick: handleClickArrowBtn,
        label: props.title
      }, null, 8, ["tabindex", "label"])
    ])
  ]))
}
}

})